import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8h4l-2 8","key":"svg-0"}]]

const IconNumber7Small = createReactComponent('outline', 'number-7-small', 'Number7Small', __iconNode);

export default IconNumber7Small;